import React from "react";

import ConfirmLogo from "./svg/ConfirmLogo";
import CloseIconX from "./svg/CloseIconX";

const DatePicker = require("react-mobile-datepicker");

interface CustomLetterPickerProps {
  onShowLetterPicker: boolean;
  onSetShowLetterPicker: any;
  onSetInputLetterValue:any;
  onLetterChange : any
}

const CustomLetterPicker: React.FC<CustomLetterPickerProps> = ({onShowLetterPicker, onSetShowLetterPicker,onSetInputLetterValue,onLetterChange}) => {

  const setDateValue = (item: Date) => {

    let index = parseInt(item.getFullYear().toString().slice(-2));
    onSetInputLetterValue(alphabets[index - 1]);
    onLetterChange(alphabets[index - 1])
    onSetShowLetterPicker(false);
  }
  const alphabets = ["الف", "ب", "پ", "ت", "ث", "ج", "چ", "ح", "خ", "د", "ذ", "ر", "ز", "ژ", "س", "ش", "ص", "ض", "ط", "ظ", "ع", "غ", "ف", "ق",
    "ک", "گ", "ل", "م", "ن", "و", "ه", "ی"
  ];

  const dateConfig = {
    'year': {
      format: (value : Date) => {
        let index = parseInt(value.getFullYear().toString().slice(-2));
        return alphabets[index - 1];
      },
      caption: 'Year',
      step: 1,
    }
  };

  return (
    <DatePicker
      value={new Date(2010,10,10)}
      isOpen={onShowLetterPicker}
      min={new Date(2001,1,1)}
      max={new Date(2032,12,12)}
      showHeader={false}
      theme="ios"
      dateConfig={dateConfig}
      onSelect={(item: any) => {
        setDateValue(item)
      }}
      onCancel={(e: any) => {
        onSetShowLetterPicker(false)
      }}
      confirmText={<ConfirmLogo/>}
      cancelText={<CloseIconX/>}
    />
  );
}

export default CustomLetterPicker;